export const POPOVER_CONTENT = `
  Oops! We had to change the programming language to match your peer's background.
  Talk to them and decide which language works best for each of you.
  Change it at will when it's your turn to be interviewed!
`;

export const POPOVER_BUTTON_LABEL = `Got it, I forgive but not forget!`;
